export default {

  // 在场车辆
  ON_SITE_CARS: 'ON_SITE_CARS',

  // 施工车辆
  RUN_CARS: 'RUN_CARS',

  // 施工车辆
  WAIT_CARS: 'WAIT_CARS',

  // 超时车辆
  OVERDUE_CARS: 'OVERDUE_CARS',

  // 今日车辆
  TODAY_CARS: 'TODAY_CARS',

  // 延迟交车
  DELAY_CARS: 'DELAY_CARS',

  // 今日应交
  DUE_TODAY_CARS: 'DUE_TODAY_CARS',

  // 返工车辆
  REWORK_CARS: 'REWORK_CARS',

  // 今日已交
  TODAY_DELIVERY_CARS: 'TODAY_DELIVERY_CARS',

  // 中断车辆
  INTERRUPT_CARS: 'INTERRUPT_CARS',

  // 明日应交
  DUE_TOMORROW_CARS: 'DUE_TOMORROW_CARS'
}
